<template>
  <table class="data-table journal-table">
    <colgroup>
      <col style="width: 100px"/>
      <col style="width: 120px"/>
      <col style="width: 100px"/>
      <col style="width: 150px"/>
      <col style="width: auto"/>
      <col style="width: auto"/>
      <col v-if="admin" style="width: 65px"/>
    </colgroup>
    <thead>
    <tr>
      <th>Платформа</th>
      <th>Обычных игр</th>
      <th>Экстра игр</th>
      <th>Событие</th>
      <th>Описание</th>
      <th>Комментарий</th>
      <th v-if="admin"></th>
    </tr>
    </thead>
    <tbody>
    <template v-for="day in journalDays" :key="day.id">
      <tr :class="day.queueDay ? 'queue-day-row' : 'day-row'">
        <td colspan="6">
          <span v-if="!day.queueDay">День: {{ day.day }} ({{ day.dayFormatted }})</span>
          <span v-else>Очередь</span>
        </td>
        <td v-if="admin">
          <div class="td-actions" v-if="!day.queueDay">
            <button class="btn-transparent" title="Редактировать"
                    @click="$emit('editDay', day)">
              <font-awesome-icon icon="fa-solid fa-pen" class="edit-icon"/>
            </button>
            <button class="btn-transparent" title="Отменить действие" v-if="day.lastRecord"
                    @click="$emit('cancelLastEvent')">
              <font-awesome-icon icon="fa-solid fa-trash" class="delete-icon"/>
            </button>
          </div>
        </td>
      </tr>
      <tr v-for="entry in day.entries" :key="entry.id" :class="entry.eventTypeClass">
        <template v-if="!day.queueDay">
          <td style="text-align: center">{{ entry.platformName }}</td>
          <td style="text-align: center">{{ entry.gameCount }}</td>
          <td style="text-align: center">{{ entry.extraGameCount }}</td>
        </template>
        <template v-else>
          <td colspan="3"></td>
        </template>
        <td>{{ entry.eventTypeName }}</td>
        <td class="td-description">
          <pre>{{ entry.description }}</pre>
        </td>
        <td class="td-comment">
          <pre>{{ entry.comment }}</pre>
        </td>
        <td v-if="admin">
          <div class="td-actions">
            <button class="btn-transparent" title="Редактировать"
                    @click="$emit('editJournalEntry', entry)">
              <font-awesome-icon icon="fa-solid fa-pen" class="edit-icon"/>
            </button>
            <button class="btn-transparent" title="Отменить действие" v-if="entry.lastRecord"
                    @click="$emit('cancelLastEvent')">
              <font-awesome-icon icon="fa-solid fa-trash" class="delete-icon"/>
            </button>
            <button class="btn-transparent" title="Удалить из очереди" v-if="day.queueDay"
                    @click="$emit('deleteQueueEntry', entry)">
              <font-awesome-icon icon="fa-solid fa-trash" class="delete-icon"/>
            </button>
          </div>
        </td>
      </tr>
    </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "JournalList",
  props: ["journalDays"],
  emits: ["editDay", "editJournalEntry", "cancelLastEvent", "deleteQueueEntry"],
  computed: {
    admin: function () {
      return localStorage.getItem("token") !== null
    },
  },
  methods: {}
}
</script>

<style scoped>

.journal-table .day-row {
  background-color: #444;
}

.journal-table .day-row>td:first-child,
.journal-table .queue-day-row>td:first-child{
  padding-left: 10px;
  font-size: 17px;
}

.journal-table .day-row td,
.journal-table .queue-day-row td{
  font-size: 16px;
  font-weight: bold;
  padding: 12px 4px;
}

.journal-table .queue-day-row{
  background-color: #444;
}

.journal-table .queue{
  background-color: #707070;
}

.journal-table .game-rolled {
  background-color: #0385c3;
}

.journal-table .game-started {
  background-color: #019b8c;
}

.journal-table .game-continued {
  background-color: #945710;
}

.journal-table .game-reroll {
  background-color: #6a6a6a;
}

.journal-table .game-completed {
  background-color: #3c743c;
}

.journal-table .game-dropped {
  background-color: #870000;
}

.journal-table .wheel {
  background-color: #b76310;
}

.journal-table .plus-game {
  background-color: #870000;
}

.journal-table .minus-game {
  background-color: #0385c3;
}

.journal-table .plus-extra-game {
  background-color: #6d00b8;
}

.journal-table .minus-extra-game {
  background-color: #019b8c;
}

.journal-table .platform-changed {
  background-color: #051595;
}

.journal-table .item-added {
  background-color: #6d00b8;
}

.journal-table .item-used{
  background-color: #b76310;
}

.journal-table .other{
  background-color: #019b8c;
}

.delete-icon {
  color: #eb1f1f;
}

.edit-icon {
  color: var(--edit-icon-color);
}

.td-actions button {
  padding: 2px;
}

.td-actions button:not(:last-child) {
  margin-right: 12px;
}

</style>